import { z } from "zod";

const UpdateAuditRegistrySchema = z
  .object({
    id: z.string().uuid(),
    name: z
      .string()
      .min(1, { message: "Name is required." })
      .max(256, { message: "Name must not be longer than 400 characters." }),
    description: z.string().optional().nullable(),
    shortCode: z
      .string()
      .min(1, { message: "Short code is required." })
      .max(100, { message: "Short code must not be longer than 30 characters." }),
    shortCodeFormat: z
      .string()
      .min(1, { message: "Short code is required." })
      .max(30, { message: "Short code must not be longer than 30 characters." }),
    creatorRoleId: z.string().uuid().optional().nullable(),
    assignmentRoleId: z.string().uuid().optional().nullable(),
    auditorRoleId: z.string().uuid().optional().nullable(),
  })
  .strict();

export default UpdateAuditRegistrySchema;
